<script>

import functions from '../../mixins/import/handle_invalid_rows.js';

export default {
	data() {
		return {
			path: '/import-customers/'
		}
	},
	mixins: [functions],
	methods: {
		async skipImport() {
			this.skippingIsLoading = true;
			this.errors = {};

			await axios.post(this.path + this.id + '/handle-invalid-row', {
				id: this.currentRow.data.id,
				deleted_row: true
			}).then(response => {

				this.invalidRows = this.invalidRows.filter(function(value) {
					return (value.data.id !== this);
				}, this.currentRow.data.id);

				this.rowCount = this.invalidRows.length;

				if (this.invalidRows.length === 0) {
					window.location = '/import/' + this.id +  '/handle-duplicates';
					return;
				}

				this.currentRow = this.invalidRows[0];
				this.skippingIsLoading = false;

			}).catch(error => {

				if (error.response.data && error.response.data.rows && error.response.data.rows.length) {
					this.setRows(error.response.data.rows);
				} else if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				this.skippingIsLoading = false;

			});

		},
		async onConfirm() {

			this.isLoading = true;
			this.errors = {};

			await axios.post(this.path + this.id + '/handle-invalid-row', {
				id: this.currentRow.data.id,
				first_name: this.currentRow.data.first_name,
				last_name: this.currentRow.data.last_name,
				phone: this.currentRow.data.phone,
				email: this.currentRow.data.email,
			}).then(response => {

				this.invalidRows = this.invalidRows.filter(function(value) {
					return (value.data.id !== this);
				}, this.currentRow.data.id);

				this.rowCount = this.invalidRows.length;

				if (this.invalidRows.length === 0) {
					window.location = '/import/' + this.id +  '/handle-duplicates';
					return;
				}

				this.currentRow = this.invalidRows[0];
				this.isLoading = false;

			}).catch(error => {

				if (error.response.data && error.response.data.rows && error.response.data.rows.length) {
					this.setRows(error.response.data.rows);
				} else if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				this.currentRow.errors = [];
				this.isLoading = false;

			});
		},
		async loadInvalidRows() {

			await axios.get(this.path + this.id + '/get-invalid-rows').then(response => {

				if (response.data.rows.length) {
					this.setRows(response.data.rows);
					this.pageIsLoading = false
				} else {
					window.location = '/import/' + this.id +  '/handle-duplicates';
				}

			}).catch(error => {

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				this.pageIsLoading = false

			});

		}
	}
}

</script>